import { render, staticRenderFns } from "./PropertiesSelector.vue?vue&type=template&id=432ea79f"
import script from "./PropertiesSelector.vue?vue&type=script&lang=js"
export * from "./PropertiesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports